import React, { useState } from "react";
import { Steps, Button, message, ConfigProvider } from "antd";
import { Flex } from "antd";
import './CalendarTour.css'
const { Step } = Steps;
const CalendarTour = () => {
    const [currentStep, setCurrentStep] = useState(0);

    const steps = [
        {
            title: "Bem-vindo",
            content: "Bem-vindo ao seu calendário! Aqui estão os links de navegação.",
        },
        {
            title: "Conteúdo Principal",
            content: "Este é o conteúdo principal do seu calendário. Você pode ver o menu para cada dia aqui.",
        },
        {
            title: "Adicionar Pratos",
            content: "Adicione novos pratos para cada dia clicando no botão abaixo.",
        },
    ];

    const nextStep = () => {
        setCurrentStep(currentStep + 1);
    };

    const prevStep = () => {
        setCurrentStep(currentStep - 1);
    };

    const finishTour = () => {
        message.success("Tour concluído com sucesso!");
    };

    return (
        <Flex vertical align="center" style={{ margin: " 0 2rem", height: "100%" }}>
            <Steps current={currentStep} size="small">
                {steps.map((item) => (
                    <Step key={item.title} title={item.title} />
                ))}
            </Steps>
            <Flex vertical align="center" style={{ marginTop: "20px" }}>
                <div className="steps-content">{steps[currentStep].content}</div>
                <div className="steps-action" style={{ marginTop: "20px" }}>
                    {currentStep < steps.length - 1 && (
                        <Button type="primary" onClick={nextStep} style={{
                            backgroundColor: "#F36527",
                        }}>
                            Próximo
                        </Button>
                    )}
                    {currentStep === steps.length - 1 && (
                        <Button type="primary" onClick={finishTour} style={{
                            backgroundColor: "#F36527",
                        }}>
                            Concluir
                        </Button>
                    )}
                    {currentStep > 0 && (
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimaryHover: "#F36527",
                                }
                            }}>
                            <Button style={{ margin: "0 8px" }} onClick={prevStep} className="btn-prev">
                                Anterior
                            </Button>
                        </ConfigProvider>
                    )}
                </div>
            </Flex>
        </Flex>
    );
};

export default CalendarTour;
